/**
 * Seamly Channel API
 * The API for Seamly Channel REST API <br/><br/> **Please note**: You can view which schemas apply to an endpoint by navigating to the response of an endpoint and then clicking on *Schema*, right next to *Example Value*. By default example values are shown for each response.
 *
 * The version of the OpenAPI document: 2.0.0
 * Contact: support@seamly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UIPayloadBody } from './ui-payload-body';

export interface UIPayload {
    type: UIPayload.TypeEnum;
    body: UIPayloadBody;
    /**
     * Message id
     */
    id: string;
    /**
     * Timestamp of the message in microseconds
     */
    occurredAt: number;
    /**
     * Identifier of the transaction this message belongs to. Aids to group and link messages together. When a bot service for instance emits multiple messages at once they\'ll all have the same transactionId.
     */
    transactionId: string | null;
}
export namespace UIPayload {
    export type TypeEnum =
        | 'history_changed'
        | 'idle_detach_countdown_cancelled'
        | 'idle_detach_countdown_elapsed'
        | 'idle_detach_countdown'
        | 'loading'
        | 'resume_conversation_prompt'
        | 'user_first_response';
    export const TypeEnum = {
        HistoryChanged: 'history_changed' as TypeEnum,
        IdleDetachCountdownCancelled: 'idle_detach_countdown_cancelled' as TypeEnum,
        IdleDetachCountdownElapsed: 'idle_detach_countdown_elapsed' as TypeEnum,
        IdleDetachCountdown: 'idle_detach_countdown' as TypeEnum,
        Loading: 'loading' as TypeEnum,
        ResumeConversationPrompt: 'resume_conversation_prompt' as TypeEnum,
        UserFirstResponse: 'user_first_response' as TypeEnum
    };
}
